export enum AffiliateCommissionPayoutRequestStatusEnum {
  ACTIVE = 'active',
  PAID = 'paid',
}
